import { Card, Text } from '@mantine/core';
import {
  SessionTypeSelector,
  type SessionTypeProductSummary,
} from '../../../../components/shared/SessionTypeSelector';
import { SessionType } from '../types';

interface SessionTypeStepProps {
  activeStep: number;
  selectedSessionType: SessionType | null;
  setSelectedSessionType: (type: SessionType) => void;
  setActiveStep: (step: number) => void;
  scenarioProducts: SessionTypeProductSummary[];
  experienceProducts: SessionTypeProductSummary[];
  subscriptionsLoading?: boolean;
}

export function SessionTypeStep({
  activeStep,
  selectedSessionType,
  setSelectedSessionType,
  setActiveStep,
  scenarioProducts,
  experienceProducts,
  subscriptionsLoading,
}: SessionTypeStepProps) {
  return (
    <Card
      withBorder
      p='md'
      style={{
        opacity: activeStep === 2 ? 1 : 0.8,
      }}
    >
      <Text fw={500} size='lg'>
        3. Scegli il tipo di sessione
      </Text>
      <SessionTypeSelector
        selectedType={selectedSessionType}
        scenarioProducts={scenarioProducts}
        experienceProducts={experienceProducts}
        loading={subscriptionsLoading}
        onSelect={type => {
          setSelectedSessionType(type);
          setActiveStep(3);
        }}
      />
    </Card>
  );
}
